export default "__VITE_ASSET__B6G74HzE__"